// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-core-pages-page-template-tsx" + "-" + "67595d4f470cc8e4a237" + ".js";
};